import { request } from "../utils/request";
export default{
    getEventList:async(payload,signal)=>{
        return request.get("/event/list",{params:payload,signal});
    },
    getEventDetails:async(payload)=>{
        return request.get("/event/details/"+payload.slug);
    },
    eventBooking:async(payload)=>{
        return request.post("/event/booking");
    },
    getCountryList:async()=>{
        return request.get("getCountryList");
    }
}
